import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

const CustomHelmet = props => {
  const { title = 'title.common', subTitle = '', needIntl = true } = props;
  const { formatMessage } = useIntl();
  const label = needIntl ? `${formatMessage({ id: title })} - ${formatMessage({ id: subTitle })}` : `${title}`;
  return (
    <Helmet>
      <title>{label}</title>
      <meta name="description" content={label} />
    </Helmet>
  );
};

export default CustomHelmet;
